module.exports = __webpack_public_path__ + "static/img/background.fd137a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/background.jpg
// module id = bjg2
// module chunks = 1